export * from '@jucy/rentals-api-client/rentals-api-v3/models/PaymentConfig';
